import React from "react";
import PropTypes from "prop-types";
import { MrbPage, MrbPageHeader, MrbPageContentHeader } from "mrb/components/layout";
import { MrbTable } from "mrb/components/table";
import { MrbQuerySearchInput } from "mrb/components/input";
import { MrbButton } from "mrb/components/button";
import { MrbSelect } from "mrb/components/select";
import { MrbRouterLink } from "mrb/core/infrastructure/router";
import { TableNoDataOverlay } from "common/components";
import { defaultTemplate } from "common/hoc";

function LoadioContentProfileArtistsTemplate({ loadioContentProfileArtistsViewStore, t }) {
    const {
        profileName,
        statusFilterStore,
        genreSelectStore,
        queryUtility,
        gridStore,
        enableSelected,
        disableSelected,
        enableAll,
        disableAll,
        canEnableSelected,
        canDisableSelected,
        canEnableAll,
        canDisableAll,
        hasSelection,
        selectedCount,
    } = loadioContentProfileArtistsViewStore;

    return (
        <MrbPage>
            <MrbPageHeader>
                <div className="c-page__header--top">
                    <div>
                        <MrbRouterLink routeName="master.administration.loadio-dashboard.profile.list">
                            <span className="display--ib u-mar--right--tny align--v--middle">
                                <i className="u-icon u-icon--med u-icon--back" />
                            </span>
                            {t("ADMINISTRATION.LOADIO_DASHBOARD.PROFILE_ARTISTS.BACK_TO_PROFILES")}
                        </MrbRouterLink>
                    </div>
                </div>
            </MrbPageHeader>

            <MrbPageContentHeader classNameOverride="u-mar--bottom--sml">
                <div className="u-mar--bottom--med">
                    <p className="u-type--lrg u-mar--none">{profileName}</p>
                </div>
                <div className="u-display--flex u-gap--sml f--align--items--center">
                    <MrbQuerySearchInput queryUtility={queryUtility} />
                    <div className="f--shrink--0 f--basis--200">
                        <MrbSelect
                            t={t}
                            store={statusFilterStore}
                            classNameExtend="c-dropdown--dark c-dropdown--sml"
                            styles={{
                                valueContainer: (base) => ({ ...base, overflow: "visible" }),
                                singleValue: (base) => ({ ...base, overflow: "visible" }),
                            }}
                        />
                    </div>
                    {hasSelection ? (
                        <div className="u-display--flex u-gap--sml f--align--items--center u-mar--left--auto">
                            <MrbButton
                                t={t}
                                onClick={enableSelected}
                                disabled={!canEnableSelected}
                                label="ADMINISTRATION.LOADIO_DASHBOARD.PROFILE_ARTISTS.BUTTONS.ENABLE_SELECTED"
                                className="c-btn c-btn--base c-btn--primary"
                            />
                            <MrbButton
                                t={t}
                                onClick={disableSelected}
                                disabled={!canDisableSelected}
                                label="ADMINISTRATION.LOADIO_DASHBOARD.PROFILE_ARTISTS.BUTTONS.DISABLE_SELECTED"
                                className="c-btn c-btn--base c-btn--ghost"
                            />
                            <span className="u-type--color--secondary u-type--med">
                                {t("ADMINISTRATION.LOADIO_DASHBOARD.PROFILE_ARTISTS.SELECTED_COUNT", {
                                    count: selectedCount,
                                })}
                            </span>
                        </div>
                    ) : (
                        <div className="u-display--flex u-gap--sml f--align--items--center u-mar--left--auto">
                            <div className="f--shrink--0 f--basis--240">
                                <MrbSelect
                                    t={t}
                                    store={genreSelectStore}
                                    classNameExtend="c-dropdown--dark c-dropdown--sml"
                                    styles={{
                                        valueContainer: (base) => ({ ...base, overflow: "visible" }),
                                        singleValue: (base) => ({ ...base, overflow: "visible" }),
                                    }}
                                />
                            </div>
                            <MrbButton
                                t={t}
                                onClick={enableAll}
                                disabled={!canEnableAll}
                                label="ADMINISTRATION.LOADIO_DASHBOARD.PROFILE_ARTISTS.BUTTONS.ENABLE_ALL"
                                className="c-btn c-btn--base c-btn--primary"
                            />
                            <MrbButton
                                t={t}
                                onClick={disableAll}
                                disabled={!canDisableAll}
                                label="ADMINISTRATION.LOADIO_DASHBOARD.PROFILE_ARTISTS.BUTTONS.DISABLE_ALL"
                                className="c-btn c-btn--base c-btn--ghost"
                            />
                        </div>
                    )}
                </div>
            </MrbPageContentHeader>

            <MrbTable
                t={t}
                tableStore={gridStore}
                className="ag-theme-alpine u-mar--bottom--sml"
                emptyStateRender={TableNoDataOverlay}
            />
        </MrbPage>
    );
}

LoadioContentProfileArtistsTemplate.propTypes = {
    loadioContentProfileArtistsViewStore: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default defaultTemplate(LoadioContentProfileArtistsTemplate);
